import EdazPhoneInput from "@edaz/edazkit/InputPhone";
import { observer } from "mobx-react-lite";
import React from "react";
import { Input } from "@frui.ts/bootstrap";
import { Col, Form } from "react-bootstrap";
import FormLabel from "controls/formLabel";
import FormGroup from "controls/formGroup";
import type UserCreateViewModel from "../../../viewModels/users/users/userCreateViewModel";
import type UserEditationViewModel from "../../../viewModels/users/users/userEditationViewModel";

export interface UserFormProps {
  vm: UserCreateViewModel | UserEditationViewModel;
  children?: React.ReactNode;
}

const UserForm = observer((props: UserFormProps) => {
  const { vm, children } = props;
  const disabled = !vm.isEditable;

  return (
    <>
      <Form.Row>
        <FormGroup as={Col} target={vm.item} property="firstName">
          <FormLabel>{vm.translateAttribute("firstName")}</FormLabel>
          <Input disabled={disabled} />
        </FormGroup>
        <FormGroup as={Col} target={vm.item} property="lastName">
          <FormLabel>{vm.translateAttribute("lastName")}</FormLabel>
          <Input disabled={disabled} />
        </FormGroup>
      </Form.Row>
      <Form.Row>
        <FormGroup as={Col} target={vm.item} property="email">
          <FormLabel>{vm.translateAttribute("email")}</FormLabel>
          <Input disabled={disabled} />
        </FormGroup>
        <FormGroup as={Col} target={vm.item} property="phoneNumber">
          <FormLabel>{vm.translateAttribute("phoneNumber")}</FormLabel>
          <EdazPhoneInput disabled={disabled} />
        </FormGroup>
      </Form.Row>
      {children}
    </>
  );
});

export default UserForm;
